module.exports = __webpack_public_path__ + "img/pic_ys_02.5cd6466a.png";